import { SnackbarProvider } from "notistack";

function SnackBar({ children }) {
	return (
		<SnackbarProvider
			maxSnack={3}
			autoHideDuration={3000}
			preventDuplicate>
			{children}
		</SnackbarProvider>
	);
}

export default SnackBar;
